export const scrollToChart = (chartRef: React.RefObject<HTMLElement>) => {
  // Set the viewport meta tag to prevent zooming
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
  }

  // Scroll to the chart
  chartRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const formatCurrency = (value: string | number): string => {
  // Convert string to number if needed
  const numValue = typeof value === 'string' ? Number(value) : value;
  
  // Handle negative numbers
  const isNegative = numValue < 0;
  const absValue = Math.abs(numValue);
  
  // For numbers up to $999,999, show full number
  if (absValue <= 999999) {
    return `${isNegative ? '-' : ''}$${Math.round(absValue).toLocaleString()}`;
  }
  
  // For larger numbers, abbreviate with M, B, T
  let suffix = '';
  let scaledValue = 0;
  
  if (absValue >= 1e12) {
    // Trillions
    suffix = 'T';
    scaledValue = absValue / 1e12;
  } else if (absValue >= 1e9) {
    // Billions
    suffix = 'B';
    scaledValue = absValue / 1e9;
  } else {
    // Millions
    suffix = 'M';
    scaledValue = absValue / 1e6;
  }
  
  // Format to match examples: $123,456,789 → $123.456M, $1,234,567 → $1.234M
  // Always show 3 decimal places initially, then remove trailing zeros
  let formattedValue = scaledValue.toFixed(3);
  
  // Remove trailing zeros but keep the format readable
  formattedValue = formattedValue.replace(/\.?0+$/, '');
  
  return `${isNegative ? '-' : ''}$${formattedValue}${suffix}`;
};

const chartUtils = { scrollToChart, formatCurrency };
export default chartUtils;
